import { render } from "./LoadingLabel.vue?vue&type=template&id=8891f926"
import script from "./LoadingLabel.vue?vue&type=script&lang=js"
export * from "./LoadingLabel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__